<aside class="layout--stepper__aside">
  @for (group of menu; track group; let i = $index) {
    <section class="layout--stepper__group__wrapper">
      <div
        class="layout--stepper__group"
        (click)="scrollToSection(group)"
        [ngClass]="{ 'is-active': group.prop === activeItem }"
      >
        <div class="layout--stepper__group__indicator">
          <p
            class="t-data t-bold"
            [attr.data-test-id]="'asideMenuIndicator_' + group.prop"
          >
            {{ i + 1 }}
          </p>
        </div>
        <p
          class="t-data t-caps"
          [attr.data-test-id]="'asideMenuHeader_' + group.prop"
        >
          {{ group.header }}
        </p>
      </div>
    </section>
  }
</aside>
